/**
 * Created by Ivan on 29.07.2026
 */

const FieldReward = function (unit, options) {
    UnitComponent.call(this, unit);

    this.rewards = options.reward;
    this.rewardsList = new RewardsList(this.rewards, {
        event: cleverapps.EVENTS.EARN.FIELD,
        toBubbleStack: true
    });

    Merge2.current.pendingFieldRewards = Merge2.current.pendingFieldRewards || [];
    Merge2.current.counter.registerStage(-2, FieldReward.showPendingRewards);
};

FieldReward.prototype = Object.create(UnitComponent.prototype);
FieldReward.prototype.constructor = FieldReward;

FieldReward.prototype.isActive = function () {
    return !this.collected && this.unit.isInFog();
};

FieldReward.prototype.open = function () {
    if (this.collected) {
        return;
    }

    this.collected = true;

    this.rewardsList.receiveRewards();

    Merge2.current.pendingFieldRewards.push(this.rewardsList);

    if (this.view) {
        this.view.collect();
    }

    cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
};

FieldReward.prototype.getUnitsLibraryUnit = function () {
    const rewards = this.rewardsList.listRewards();
    const unitRewards = rewards.filter((reward) => reward.type === "units");

    return rewards.length === 1 && unitRewards.length === 1 && unitRewards[0].getValue();
};

FieldReward.prototype.handleClick = function () {
    if (!this.isActive()) {
        return false;
    }

    const unitsLibraryUnit = this.getUnitsLibraryUnit();
    if (unitsLibraryUnit) {
        this.unit.squeeze();
        FieldReward.showUnitsLibrary(unitsLibraryUnit);
        return true;
    }

    const rewards = this.rewardsList.listRewards();
    if (rewards.length > 1 && this.view) {
        this.unit.squeeze();
        this.view.showTooltip();
        return true;
    }

    return false;
};

FieldReward.showUnitsLibrary = function (unit) {
    cleverapps.focusManager.display({
        focus: "HelpButtonClicked",
        action: function (f) {
            new Merge2UnitsLibraryWindow({ code: unit.code, stage: unit.stage });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

FieldReward.showPendingRewards = function () {
    const pending = Merge2.current.pendingFieldRewards;

    if (pending.length === 0) {
        return;
    }

    Merge2.current.pendingFieldRewards = [];

    const actions = pending.map((reward) => (f) => {
        new RewardWindow(reward, {
            title: Messages.get("FieldRewardWindow.title")
        });
        cleverapps.focusManager.onceNoWindowsListener = f;
    });

    cleverapps.focusManager.display({
        focus: "fieldReward",
        stack: true,
        actions
    });
};
